/* eslint-disable react/jsx-no-bind */
import moment from 'moment-timezone';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { DateFormat } from 'stageclip-common';

import { required } from '../form/formValidations';
import { FormId } from '../../constants/formId';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../componentBase';

import { AppDateTimeField } from 'components/form/appDateTimeField';

interface BaseClientFormOwnProps {
  formId: FormId;
  onTimezoneChange: (isDst: boolean) => void;
}

interface BaseClientFormStateProps extends BaseStateProps {
  formData: any;
}

type BaseClientFormDispatchProps = BaseDispatchProps;

type BaseClientFormState = { dstDisabled: boolean };

class BaseDownloadSummaryForm extends ComponentBase<
  BaseClientFormOwnProps,
  BaseClientFormStateProps,
  BaseClientFormDispatchProps,
  BaseClientFormState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      dstDisabled: false,
    };
  }

  protected getClientTimezone() {
    return moment.tz.guess();
  }

  protected loggedInRender() {
    return (
      <>
        <div style={{ height: '300px' }}>
          <AppDateTimeField
            name="dateFrom"
            label="Start Date"
            timezone={this.getClientTimezone()}
            key="startDate"
            dst={false}
            isTimeSelect={false}
            dateFormat={DateFormat.DateOnly}
            validate={[required]}
          />
          <AppDateTimeField
            name="dateTo"
            label="End Date"
            timezone={this.getClientTimezone()}
            key="EndDate"
            dst={false}
            isTimeSelect={false}
            dateFormat={DateFormat.DateOnly}
            validate={[required]}
          />
        </div>
      </>
    );
  }
}

function mapStateToProps(state: ClippingPlatformState): BaseClientFormStateProps {
  const form = state.form[FormId.DownloadSummaryForm];

  return {
    ...baseMapStateToProps(state),
    formData: form ? form.values : undefined,
  };
}

function mapDispatchToProps(dispatch: Dispatch): BaseClientFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseDownloadSummaryForm);
